import styled from 'styled-components';
import WhatsAppNoramlSVG from '../../assets/common/normal-wa.svg';

const WhatsAppNormalIcon = styled(WhatsAppNoramlSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '6rem'};
  height: ${props => props.height || '3.9rem'};
`;

export default WhatsAppNormalIcon;
